<template>
  <div class="assurance">
    <input-label :text="$t('assurance.declaration.label')"/>
    <input-selector
      v-model="declarationSync"
      :options="declarationOptions"/>
    <next-transition :visible="displayDeclarationLabel">
      <input-label :text="$t('assurance.declaration.moreLabel')"/>
      <input-number-range
        :min="15000"
        :step="5000"
        v-model="declarationSync"
      >
      </input-number-range>
    </next-transition>
    <next-transition :visible="declarationSync !== undefined">
      <input-label :text="$t('assurance.additional.label')"/>
      <input-selector v-model="additionalSync" :options="additionalOptions"/>
    </next-transition>
  </div>
</template>

<script>
import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import { INSURANCE_TYPE } from '@/store/modules/serviceOfferStore';
import NextTransition from '../utils/NextTransition.vue';
import InputNumberRange from '../utils/InputNumberRange.vue';

export default {
  name: 'assurance',
  components: {
    InputNumberRange,
    NextTransition,
    InputLabel,
    InputSelector,
  },
  computed: {
    declarationSync: {
      get() {
        return this.$store.getters['serviceOfferStore/insurance/value'];
      },
      set(declaration) {
        this.$store.commit('serviceOfferStore/SET_INSURANCE_VALUE',
          declaration, { root: true });
      },
    },
    displayDeclarationLabel() {
      return this.declarationSync >= 20000;
    },
    declarationOptions() {
      const values = [
        {
          value: 5000,
          label: `${this.$t('assurance.declaration.options.5000')} ${this.$t('base.currency')}`,
        },
        {
          value: 10000,
          label: `${this.$t('assurance.declaration.options.10000')} ${this.$t('base.currency')}`,
        },
        {
          value: 15000,
          label: `${this.$t('assurance.declaration.options.15000')} ${this.$t('base.currency')}`,
        },

      ];
      if (this.declarationSync <= 20000 || this.declarationSync === undefined) {
        values.push({
          value: 20000,
          label: `${this.$t('assurance.declaration.options.20000')} ${this.$t('base.currency')}`,
        });
      } else {
        values.push({
          value: this.declarationSync,
          label: `${this.$t('assurance.declaration.options.20000')} ${this.$t('base.currency')}`,
        });
      }

      return values;
    },
    additionalSync: {
      get() {
        const assurance_type = this.$store.getters['serviceOfferStore/insurance/type'];
        return !assurance_type ? assurance_type : assurance_type === INSURANCE_TYPE.COMPLEMENTARY;
      },
      set(type) {
        this.$store.commit('serviceOfferStore/SET_INSURANCE_TYPE',
          type ? INSURANCE_TYPE.COMPLEMENTARY : INSURANCE_TYPE.CLASSIC,
          { root: true });
      },
    },
    additionalOptions() {
      return [
        {
          value: true,
          label: this.$t('base.yes'),
        },
        {
          value: false,
          label: this.$t('base.no'),
        },
      ];
    },
  },
  data() {
    return {
      assuranceValue: 20000,
    };
  },
  watch: {
    assuranceValue(value) {
      this.$store.dispatch('serviceOfferStore/setDeclaration',
        value, { root: true });
    },
  },
};
</script>

<style scoped lang="scss">

.assurance {
  &__form {
    &__actions {
      text-align: right;
    }
  }
}

</style>
